import React, { createContext, ReactNode, useEffect, useState } from 'react';
import useStore from '../components/Hooks/useStore';

type BannerContextType = {};

export const BannerContext = createContext<BannerContextType | null>(null);

type BannerProviderProps = {
  children: ReactNode;
};

export const BannerProvider: React.FC<BannerProviderProps> = ({ children }) => {
  const [, setters] = useStore();

  const {
    banner: { setBannerConfigs },
  } = setters;
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    setBannerConfigs();
    setInitialized(true);
  }, []);

  return (
    <BannerContext.Provider value={{}}>
      {initialized ? children : <></>}
    </BannerContext.Provider>
  );
};
